export default __webpack_public_path__ + "static/socialmindr-bg-video-8befcd5adde5361bf62d190670cfc22f.webm";